import { Stack } from "@mui/material";
import React from "react";
const ErrorPage = () => {
  return (
    <Stack>
      
      <img
      alt="error"
        margin="auto"
        // mt="20px"
        
        w="100%"
        height='714px'
        src="https://raw.githubusercontent.com/sujjwal21/Pear.com/main/cw-project/src/assets/error.png"
      />
    </Stack>
  );
};
export default ErrorPage;
